import { NgModule } from '@angular/core';
import { ProductPageEventBuilder } from './product-page-event.builder';

@NgModule({})
export class ProductPageEventModule {
  constructor(_productPageEventBuilder: ProductPageEventBuilder) {}
}
